import React from "react";
import { Link } from "react-router-dom";

const BackBtn = ({ location }) => {
  return (
    <div>
      <Link to={location} style={{ color: "inherit" }}>
        <i
          style={{ fontSize: "25px" }}
          className="far fa-arrow-alt-circle-left text-muted backarrow"
        ></i>
      </Link>
    </div>
  );
};

export default BackBtn;
